import { AnswerModel } from '@/components/decision-tree/hooks';
import { useMutation, useQuery, type UseQueryOptions } from '@tanstack/react-query';
import ppraRepository, { SessionSurveyDto } from '../repositories/ppra.repository';

/**
 * Hook to get a PPRA survey by version
 */
export function useGetPpraSurvey(version: string, options?: Partial<UseQueryOptions<SessionSurveyDto>>) {
  return useQuery({
    queryKey: ['ppra', 'survey', version],
    queryFn: () => ppraRepository.createSurvey(version),
    enabled: !!version, // Only run the query if version is provided
    ...options,
  });
}

/**
 * Hook to save an answer to a PPRA survey question
 */
export function useSavePpraSurveyAnswer() {
  return useMutation({
    mutationFn: ({
      sessionSurveyId,
      surveyItemId,
      answer,
    }: {
      sessionSurveyId: string;
      surveyItemId: string;
      answer: AnswerModel;
    }) => ppraRepository.saveAnswer(sessionSurveyId, surveyItemId, answer),
  });
}
